import React, { useState } from "react";
import Header from "components/Headers/Header";
import { Col, Container, Row, Button, Modal } from "reactstrap";
import { IoMdArrowBack } from "react-icons/io";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { FaYoutube } from "react-icons/fa6";
import previewBadge from "../assets/img/custom/momentocard_preview.png";

function MEMENTOS() {
  const [modal, setModal] = useState(false);
  const [selectedSite, setSelectedSite] = useState(null);

  const toggle = () => setModal(!modal);

  const handleSiteSelection = (site) => {
    setSelectedSite(site);
    toggle();
  };

  const getContinueLink = () => {
    if (selectedSite === "fan") {
      return "https://momento-platform.web.app/auth/login?redirect=/main/gallery";
    } else if (selectedSite === "athlete") {
      return "https://momento-platform.web.app/auth/login?redirect=/main/gallery";
    }
    return "#";
  };
  return (
    <>
      <div className="trending">
        <Button className="text-white btn btn-primary mx-4 my-3" onClick={() => window.history.back()}>
          <IoMdArrowBack /> Go Back
        </Button>{" "}
        <Container className="momento-Container">
          <div className="momento  ">
            <a
              className="text-white btn btn-primary "
              href="https://youtu.be/HQsfsy2Sonc"
              target="_blank"
            >
              <FaYoutube className="youtube-icon" /> Play Video
            </a>
            <a
              className="mt-2 btn btn-primary "
              href="https://momento-platform.web.app/auth/login?redirect=/main/ad"
              target="_blank"
            >
              Go to site
            </a>
            {/* <Button
            className=" mt-2 " color="primary"
            onClick={() => handleSiteSelection('athlete')}
          >
            Go to athlete site
          </Button> */}
          </div>
        </Container>
      </div>
      {/* <Modal isOpen={modal} toggle={toggle} size="xl" className="modal-dialog modal-dialog-centered">
      <Container>
        <Row>
          <Col lg="12">
            <div className="complaint-card shadow">
              <Row className="p-4">
              <Col className="col-sm-12 col-md-7">
                  <div className="border border-dark">
                    <h1 className="font-weight-bolder text-center">
                      MEMENTOS – ATHLETE TIPS
                    </h1>
                  </div>
                  <p className="font-weight-normal mt-2">
                    <b className="text-danger">
                      You can BE CREATIVE IN MAKING&nbsp;
                    </b>
                    <b className="text-primary">MEMENTOS&nbsp;</b>You choose
                    which videos link to the QR codes. You choose the photos.
                    Your fans might REQUEST A&nbsp;
                    <b className="text-danger">
                      CUSTOM MEMENTO FROM YOU. CHECK OUT THE VIDEO.​
                    </b>
                  </p>
                  <p className="font-weight-normal mt-2">
                    Mementos at&nbsp;
                    <b className="text-dark ">
                      <b className="text-dark">Fans</b>
                      <b className="text-primary">Help</b>
                      <b className="text-danger">Players</b>
                    </b>{" "}
                    are PREPARED BY THE STUDENT ATHLETE OF FAN’S CHOICE. IF
                    ATHLETE’S SCHOOL HAS SIGNED AN IP AGREEMENT WITH FHP,
                    ATHLETE CAN USE FOOTAGE FROM SCHOOL FILES. ​&nbsp;
                    {/* <b className="text-danger">SPECIAL REQUEST</b>
                    &nbsp;for him or her to include a QR linked to a&nbsp;
                    <b className="text-primary">
                      VIDEO showing your FAV in a sports play or event you like.
                    </b> */}
      {/* &nbsp;
                  </p>

                  <p className="font-weight-normal mt-2">
                    HERE’S another important thing to Remember– up to{" "}
                    <b className="text-dark ">
                      <b className="text-danger">88%</b> of the money{" "}
                      <b className="text-dark">F</b>
                      <b className="text-primary">H</b>
                      <b className="text-danger">P</b> spend at FHP goes{" "}
                      <b className="text-danger">
                        <u> directly to Student Athletes.</u>
                      </b>
                    </b>
                  </p>
                  <p className="font-weight-normal mt-2">
                    <b className="text-dark">THANK YOU!</b>{" "}
                    <u className="text-dark">Enjoy</u> and{" "}
                    <b className="text-dark">
                      <u>TELL YOUR FRIENDS.</u>
                    </b>
                  </p>
                </Col>
                <Col className="col-sm-12 col-md-5">
                  <div className="w-full mt-5 mb-3 d-flex justify-content-center">
                    <img src={previewBadge} height={200} />
                  </div>

                  <div className="d-flex justify-content-center align-items-center mt-5">
                    <Button color="primary">
                      <a
                        href="https://www.youtube.com/watch?v=HQsfsy2Sonc"
                        target="_blank"
                        className="text-white"
                      >
                        Play Video
                      </a>
                    </Button>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a href={getContinueLink()} className="btn btn-primary">
                        Continue
                      </a>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
      </Modal> */}
    </>
  );
}

export default MEMENTOS;
